export const MODULE_NAME = 'views/cottage'

export const ALIAS_PATH = '/__nuxt-pages/casa-rural/:province()/:slug()'
